import {
	Timeline,
	TimelineConnector,
	TimelineContent,
	TimelineDot,
	TimelineItem,
	TimelineSeparator,
	timelineItemClasses,
} from "@mui/lab";
import { ReactNode } from "react";

/**
 * The profile experience timeline visual (dots + connectors), shared by the
 * person profile and the parsed-CV candidate card so they look identical. Each
 * item supplies its own content; only the dot/connector styling is shared.
 */
export const ProfileTimeline = ({
	children,
	dataComponent,
}: {
	children: ReactNode;
	dataComponent?: string;
}) => (
	<Timeline
		sx={{
			p: 0,
			m: 0,
			[`& .${timelineItemClasses.root}:before`]: { display: "none" },
		}}
		data-component={dataComponent}
	>
		{children}
	</Timeline>
);

export const ProfileTimelineItem = ({
	current = false,
	isLast = false,
	dense = false,
	children,
	dataComponent,
}: {
	/** Filled primary dot for a current role/employer. */
	current?: boolean;
	/** No connector below + no bottom padding for the last item. */
	isLast?: boolean;
	/** Tighter bottom spacing (used for nested role sub-timelines). */
	dense?: boolean;
	children: ReactNode;
	dataComponent?: string;
}) => (
	<TimelineItem
		sx={{ ...(isLast && { minHeight: "auto" }) }}
		data-component={dataComponent}
	>
		<TimelineSeparator>
			<TimelineDot
				color={current ? "primary" : undefined}
				variant={current ? "filled" : "outlined"}
				sx={{
					width: 14,
					height: 14,
					p: 0,
					m: 0,
					mt: "4px",
					borderColor: "primary.main",
					borderWidth: 2,
				}}
			/>
			{!isLast && <TimelineConnector sx={{ bgcolor: "divider" }} />}
		</TimelineSeparator>
		<TimelineContent sx={{ py: 0, pl: 1.5, pb: isLast ? 0 : dense ? 1 : 2 }}>
			{children}
		</TimelineContent>
	</TimelineItem>
);
